module.exports = __webpack_public_path__ + "static/media/avg_sessions_per_user.0b4b989e.svg";